import { useEffect, useState, useRef } from "react";
import { Button, Modal, Switch, Table, Select, Input, Spin } from "antd";
import axios from "axios";
import { Api_Url } from "../../../config/config";
import { Link } from "react-router-dom";
import { ErrorToast, SuccessToast, UpdatedToast } from "../../ToastComponent";
import UserEmployeeFilterPage from "./UserEmployeeFilterPage";
import { profile } from "../../../Routes/ImagePath";

function UserEmployeePage() {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initialOptionsFrom, setinitialOptionForm] = useState([]);
  const [assigned, setAssigned] = useState([]);
  const [isRoleModalOpen, setIsRoleModalOpen] = useState(false);
  const [isDepartmentModalOpen, setIsDepartmentModalOpen] = useState(false);
  const [isEmployeeAddModal, setIsEmployeeAddModal] = useState(false);
  const [IsBulkEmployeeAddModal, setIsBulkEmployeeAddModal] = useState(false);
  const [isEditEmployeeAddModal, setIsEditEmployeeAddModal] = useState(false);
  const [isBranchModalOpen, setIsBranchModalOpen] = useState(false);
  const [optionsFrom, setOptionsFrom] = useState([]);
  const [selectedFrom, setSelectedFrom] = useState([]);
  const [selectedTo, setSelectedTo] = useState([]);
  const [userData, setUserData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedRoleIds, setSelectedRoleIds] = useState(Number);
  const [selectedBranchIds, setSelectedBranchIds] = useState(Number);
  const [selectedDepartmentIds, setSelectedDepartmentIds] = useState(Number);
  const [selectRoles, setSelectRoles] = useState([]);
  const [selectAssignedRoles, setSelectAssignedRoles] = useState([]);
  const [selectDepartment, setSelectDepartment] = useState([]);
  const [selectAssignDepartment, setSelectAssignmentDepartment] = useState([]);
  const [tempRoleData, setTempRoleData] = useState(null);
  const [tempBranchData, setTempBranchData] = useState(null);
  const [tempDepartmentData, setTempDepartmentData] = useState(null);
  const [selectedToFromAssigned, setSelectedToFromAssigned] = useState([]);
  const [allbranch, setAllBranch] = useState([]);
  const [allRole, setAllRole] = useState([]);
  const [gender, setGender] = useState([]);
  // const [allRole, setAllRole] = useState([]);
  const [allDesignation, setAllDesignation] = useState([]);
  const [allGrade, setAllGrade] = useState([]);
  const [allDepartment, setAllDepartment] = useState([]);
  // const [isActive, SetisActive] = useState(false);
  const [isTrackingActive, setisTrackingActive] = useState(false);
  const [LocalFormData, setLocalFormData] = useState({
    id: 0,
    code: "",
    firstName: "",
    lastName: "",
    profileImageUrl: "",
    reportingManagerId: 0,
    email: "",
    mobile: "",
    gradeId: 0,
    genderId: 0,
    designationId: 0,
    branchId: 0,
    roleId: 0,
    departmentId: 0,
    password: "",
    trackingEnabled: false,
    isActive: false,
    Latitude: "",
    Longitude: "",
  });
  const [LocalEditFormData, setLocalEditFormData] = useState({
    id: 0,
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    gradeId: 0,
    genderId: 0,
    designationId: 0,
    Latitude: "",
    Longitude: "",
  });

  const selectValueOfGender = [
    { id: 1, name: "male" },
    { id: 2, name: "female" },
  ];

  const handleFilter = (data) => {
    setUserData(data);
  };

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setLocalFormData({
          ...LocalFormData,
          Latitude: latitude.toString(),
          Longitude: longitude.toString(),
        });
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  useEffect(() => {
    showDataFunction();
  }, []);

  useEffect(() => {
    setOptionsFrom(initialOptionsFrom);
  }, [initialOptionsFrom]);

  const moveRightSelected = async () => {
    const userId = tempRoleData?.userId;
    const roleId = selectedRoleIds;
    console.log(roleId);
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/UserProfile/role-assign/${userId}/${roleId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );
      if (response?.data?.succeeded) {
        console.log("API call succeeded");
        // setIsRoleModalOpen(false);
        SuccessToast(response?.data?.message);

        setSelectAssignedRoles([
          ...selectAssignedRoles,
          ...selectRoles.filter((option) => selectedFrom.includes(option.id)),
        ]);

        // Remove the moved branches from unassigned (left side)
        setSelectRoles(
          selectRoles.filter((option) => !selectedFrom.includes(option.id))
        );

        // Clear the selected branches
        setSelectedFrom([]); // Clear selected branches from the left
      } else {
        console.log("API call failed", response?.data);
      }
    } catch (error) {
      console.log(error);
      ErrorToast(error.response?.data?.message);
    }
  };

  const moveRightBranchData = async () => {
    const userId = tempBranchData?.id;
    const branchIds = selectedBranchIds; // Get the selected branch IDs from selectedFrom
    // console.log("Selected Branch IDs: ", branchIds);

    if (!branchIds || branchIds.length === 0) {
      console.log("No branches selected");
      return;
    }

    try {
      // Make the API call for branch assignment
      const response = await axios.post(
        `${Api_Url}api/v1/UserProfile/branche-assign/${userId}/${branchIds}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );

      if (response?.data?.succeeded) {
        console.log("API call succeeded");
        // setIsBranchModalOpen(false);
        SuccessToast(response?.data?.message);
        setAssigned([
          ...assigned,
          ...optionsFrom.filter((option) => selectedFrom.includes(option.id)),
        ]);

        // Remove the moved branches from unassigned (left side)
        setOptionsFrom(
          optionsFrom.filter((option) => !selectedFrom.includes(option.id))
        );

        // Clear the selected branches
        setSelectedFrom([]); // Clear selected branches from the left
      } else {
        console.log("API call failed", response?.data);
      }
    } catch (error) {
      console.error("Error in API call:", error);
      ErrorToast(error.response?.data?.message);
    }
  };

  const moveRightDepartment = async () => {
    const userId = tempDepartmentData?.id;
    const departmentId = selectedDepartmentIds;

    try {
      const response = await axios.post(
        `${Api_Url}api/v1/UserProfile/department-assign/${userId}/${departmentId}`,
        {}, // No data in body, passing empty object
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );

      if (response?.data?.succeeded) {
        console.log("API call succeeded");
        SuccessToast(response?.data?.message);

        setSelectAssignmentDepartment([
          ...selectAssignDepartment,
          ...selectDepartment.filter((option) =>
            selectedFrom.includes(option.id)
          ),
        ]);

        // Remove the moved branches from unassigned (left side)
        setSelectDepartment(
          selectDepartment.filter((option) => !selectedFrom.includes(option.id))
        );

        // Clear the selected branches
        setSelectedFrom([]); // Clear selected branches from the left
      } else {
        console.log("API call failed", response?.data);
        ErrorToast(response?.data?.message);
      }
    } catch (error) {
      console.log("API call error:", error);
      if (error.response?.status === 401) {
        ErrorToast("Unauthorized. Please login again.");
      } else {
        ErrorToast(error.response?.data?.message || "Error in API call");
      }
    }
  };

  const moveRightAllDepartment = () => {
    setSelectAssignmentDepartment([
      ...selectAssignDepartment,
      ...selectDepartment,
    ]);
    setSelectDepartment([]);
  };

  const moveLeftSelected = async () => {
    const userId = tempRoleData?.userId;
    // console.log(userId)
    const roleId = selectedRoleIds;
    console.log(roleId);
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/UserProfile/role-unassign/${userId}/${roleId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      if (response?.data?.succeeded) {
        console.log("API call succeeded");
        // setIsRoleModalOpen(false);
        SuccessToast(response?.data?.message);

        setSelectRoles([
          ...selectRoles,
          ...selectAssignedRoles.filter((option) =>
            selectedToFromAssigned.includes(option.id)
          ),
        ]);

        // Remove the moved branches from unassigned (left side)
        setSelectAssignedRoles(
          selectAssignedRoles.filter(
            (option) => !selectedToFromAssigned.includes(option.id)
          )
        );

        // Clear the selected branches
        setSelectedToFromAssigned([]); // Clear selected branches from the left
      } else {
        console.log("API call failed", response?.data);
      }
    } catch (error) {
      console.log(error);
      ErrorToast(error.response?.data?.message);
    }
  };

  const moveLeftBranchData = async () => {
    const userId = tempBranchData?.id;
    const branchIds = selectedBranchIds;

    if (!branchIds || branchIds.length === 0) {
      console.log("No branches selected");
      return;
    }

    try {
      // Make the API call for branch assignment
      const response = await axios.post(
        `${Api_Url}api/v1/UserProfile/branche-unassign/${userId}/${branchIds}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );

      if (response?.data?.succeeded) {
        console.log("API call succeeded");
        // setIsBranchModalOpen(false);
        SuccessToast(response?.data?.message);
        setOptionsFrom([
          ...optionsFrom,
          ...assigned.filter((option) =>
            selectedToFromAssigned.includes(option.id)
          ),
        ]);

        // Remove the moved branches from unassigned (left side)
        setAssigned(
          assigned.filter(
            (option) => !selectedToFromAssigned.includes(option.id)
          )
        );

        // Clear the selected branches
        setSelectedToFromAssigned([]); // Clear selected branches from the left
      } else {
        console.log("API call failed", response?.data);
      }
    } catch (error) {
      console.error("Error in API call:", error);
      ErrorToast(error.response?.data?.message);
    }
  };

  const moveLeftDepartment = async () => {
    const userId = tempDepartmentData?.id;
    const departmentId = selectedDepartmentIds;
    console.log(departmentId);
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/UserProfile/department-unassign/${userId}/${departmentId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );
      if (response?.data?.succeeded) {
        console.log("API call succeeded");
        SuccessToast(response?.data?.message);
        // setIsDepartmentModalOpen(false);

        setSelectDepartment([
          ...selectDepartment,
          ...selectAssignDepartment.filter((option) =>
            selectedToFromAssigned.includes(option.id)
          ),
        ]);

        // Remove the moved branches from unassigned (left side)
        setSelectAssignmentDepartment(
          selectAssignDepartment.filter(
            (option) => !selectedToFromAssigned.includes(option.id)
          )
        );

        // Clear the selected branches
        setSelectedToFromAssigned([]);
      } else {
        console.log("API call failed", response?.data);
        // ErrorToast(error.response?.data?.message); //------- Import By Deepak because Not Available before
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Role Data Modal function--

  const RoleDataFetchModal = (text) => {
    setIsRoleModalOpen(true);
    setTempRoleData(text);
  };

  // Branch Data Modal function--

  const BranchDataFetchModal = (text) => {
    setIsBranchModalOpen(true);
    setTempBranchData(text);
  };

  // Department Data Modal function--
  const DepartmentDataFetchModal = (text) => {
    setIsDepartmentModalOpen(true);
    setTempDepartmentData(text);
  };

  // Active Inactive Function
  const HandleActiveFuntion = async (record) => {
    console.log("text", record);
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/UserProfile/active-or-inactive/${
          record?.id
        }/${!record?.isActive}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );
      if (response?.data?.succeeded) {
        SuccessToast(response?.data?.message);
        showDataFunction();
        // SetisActive(newStatus);
      }
    } catch (error) {
      ErrorToast(error?.response?.data?.message);
    }
  };

  // Tracking Enabled Disabled Function
  const TrackingActiveFunction = async (record) => {
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/UserProfile/tracking-enabled-or-disabled/${
          record?.id
        }/${!record?.trackingEnabled}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );
      if (response?.data?.succeeded) {
        SuccessToast(response?.data?.message);
        showDataFunction();
      }
    } catch (error) {
      ErrorToast(error?.response?.data?.message);
    }
  };

  const handleClick = async (id) => {
    console.log("id", id);
    try {
      const response = await axios.get(`${Api_Url}api/v1/UserProfile/${id}`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });
      console.log("all data", response.data.data);
      setLocalEditFormData(response.data.data);
      setIsEditEmployeeAddModal(true);
    } catch (error) {
      return error.message;
    }
  };

  const EditNewEmployeeFunction = async (id) => {
    try {
      const response = await axios.put(
        `${Api_Url}api/v1/UserProfile/${id}`,
        LocalEditFormData, // Pass the form data directly if the API expects it this way
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );

      console.log(response.data);
      if (response?.data?.succeeded) {
        UpdatedToast("Successfully Updated");
        showDataFunction();
        resetForm();
        setIsEditEmployeeAddModal(false);
      }
    } catch (error) {
      console.error("Error updating employee:", error);
      UpdatedToast("Failed to update employee", "error"); // Use toast to show error feedback
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <span className="table-avatar">
          <Link className="avatar">
            <img alt="" src={profile} />
          </Link>
          <Link>
            {record?.firstName} {record?.lastName} ({record?.code})
          </Link>
        </span>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Mobile Number",
      dataIndex: "mobile",
    },
    {
      title: "Designation Name",
      dataIndex: "designationName",
    },
    {
      title: "Branch Name",
      dataIndex: "branchName",
    },
    {
      title: "Department Name",
      dataIndex: "departmentName",
    },
    {
      title: "Role Mapping",
      key: "action",
      render: (text, record) => (
        <Button
          className="badge activity-badge badge-bg-violet"
          onClick={() => RoleDataFetchModal(text)}
        >
          Role
        </Button>
      ),
    },
    {
      title: "Branch Mapping",
      key: "action",
      render: (text, record) => (
        <Button
          className="badge activity-badge badge-bg-info"
          onClick={() => BranchDataFetchModal(text)}
        >
          Branch
        </Button>
      ),
    },
    {
      title: "Department Mapping",
      key: "action",
      render: (text, record) => (
        <Button
          className="badge activity-badge badge-bg-warning"
          onClick={() => DepartmentDataFetchModal(text)}
        >
          Department
        </Button>
      ),
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      render: (text, record) => (
        <div className="dropdown action-label">
          <button
            to="#"
            className={
              record?.isActive
                ? "btn btn-white btn-sm badge-outline-success"
                : "btn btn-white btn-sm badge-outline-danger"
            }
            onClick={() => HandleActiveFuntion(record)}
          >
            {record?.isActive ? "Active" : "Inactive"}
          </button>
        </div>
      ),
    },
    {
      title: "Tracking Status",
      dataIndex: "Trscking Status",
      key: "Status",
      render: (text, record) => (
        <div className="dropdown action-label">
          <button
            to="#"
            className={
              record?.trackingEnabled
                ? "btn btn-white btn-sm badge-outline-success"
                : "btn btn-white btn-sm badge-outline-danger"
            }
            onClick={() => TrackingActiveFunction(record)}
          >
            {record?.trackingEnabled ? "Enabled" : "Disabled"}
          </button>
        </div>
      ),
    },
    {
      title: "Edit",
      dataIndex: "edit",
      render: (text, record) => (
        <div>
          {text}
          <Button
            type="primary"
            onClick={() => handleClick(record.id)}
            style={{ marginLeft: "10px" }}
          >
            <i className="fa-solid fa-pen-to-square"></i>
          </Button>
        </div>
      ),
    },
  ];

  const showDataFunction = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/UserProfile?PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );

      if (response.status === 200) {
        console.log("Raw API response:", response.data.data); // Debug this
        setUserData(response?.data?.data);
        setErrorMessage("");
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        setErrorMessage("You do not have permission to view this data.");
        setUserData([]);
      } else {
        setErrorMessage("An error occurred while fetching the data.");
      }
    }
  };

  const handleAddEmployeeFunction = () => {
    try {
      setIsEmployeeAddModal(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleBulkAddEmployeeFunction = () => {
    try {
      setIsBulkEmployeeAddModal(true);
    } catch (error) {
      console.log(error);
    }
  };

  // Role Mapping function get
  const allBranchsMappingFunc = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/UserProfile/branches/${tempBranchData?.id}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      console.log("first", response.data.data.unassigned);
      setinitialOptionForm(response?.data?.data?.unassigned);
      setAssigned(response?.data?.data?.assigned);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (tempBranchData?.id) {
      allBranchsMappingFunc();
    }
  }, [tempBranchData]);

  useEffect(() => {
    if (tempRoleData?.userId) {
      allRolesAssignFunc();
    }
  }, [tempRoleData]);

  useEffect(() => {
    if (tempDepartmentData?.id) {
      allDepartmentAssignFunc();
    }
  }, [tempDepartmentData]);

  // Data Role mapping
  const allRolesAssignFunc = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/UserProfile/roles/${tempRoleData?.userId}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      console.log("first", response.data.data.unassigned);
      setSelectRoles(response?.data?.data?.unassigned);
      setSelectAssignedRoles(response?.data?.data?.assigned);
    } catch (error) {
      console.log(error);
    }
  };

  // AllDepartment Assign
  const allDepartmentAssignFunc = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/UserProfile/departments/${tempDepartmentData?.id}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );
      console.log("first", response.data.data.unassigned);
      setSelectDepartment(response?.data?.data?.unassigned);
      setSelectAssignmentDepartment(response?.data?.data?.assigned);
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch all branches
  const AllBranchName = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setAllBranch(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch all roles
  const AllRoleName = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Role?PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setAllRole(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch all Departments
  const AllDepratmentName = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Department?PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setAllDepartment(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch all Designation
  const AllDesignationName = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Designation?PageNumber=1&PageSize=118`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setAllDesignation(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch all Grades
  const allGradeName = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Grade?PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setAllGrade(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    AllBranchName();
    AllRoleName();
    AllDepratmentName();
    AllDesignationName();
    allGradeName();
  }, []);

  const addNewEmployeeFunction = async (e) => {
    e.preventDefault();

    // Basic form validation
    if (!LocalFormData.branchId) {
      ErrorToast("Branch is required");
      return;
    }
    if (!LocalFormData.designationId) {
      ErrorToast("Designation is required");
      return;
    }
    if (!LocalFormData.reportingManagerId) {
      ErrorToast("Reporting Manager is required");
      return;
    }
    if (!LocalFormData.genderId) {
      ErrorToast("Gender is required");
      return;
    }
    if (!LocalFormData.firstName) {
      ErrorToast("First Name is required");
      return;
    }
    if (!LocalFormData.lastName) {
      ErrorToast("Last Name is required");
      return;
    }
    if (!LocalFormData.code) {
      ErrorToast("Code is required");
      return;
    }
    if (!LocalFormData.password) {
      ErrorToast("Password is required");
      return;
    }
    if (!LocalFormData.email) {
      ErrorToast("Email is required");
      return;
    }
    if (!LocalFormData.mobile || LocalFormData.mobile.length !== 10) {
      ErrorToast("Mobile is required and must be 10 digit.");
      return;
    }
    if (!LocalFormData.departmentId) {
      ErrorToast("Department is required");
      return;
    }
    if (!LocalFormData.roleId) {
      ErrorToast("Role is required");
      return;
    }
    if (!LocalFormData.gradeId) {
      ErrorToast("Grade is required");
      return;
    }

    try {
      const response = await axios.post(
        `${Api_Url}api/v1/UserProfile/add-new-employee`,
        LocalFormData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      console.log(response.data);
      if (response.data?.succeeded) {
        SuccessToast("Employee Added Successfully");
        resetForm();
      }
    } catch (error) {
      console.log(error);
      ErrorToast(
        error.response?.data?.errors?.[0]
          ? error.response.data.errors[0]
          : error.response?.data?.message || "Error adding employee"
      );
    }
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      ErrorToast("Please select a file to upload.");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("ExcelFile", selectedFile);

    try {
      const response = await axios.post(
        `${Api_Url}api/v1/UserProfile/upload-excel`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        SuccessToast(
          `${response.data.data.length} users created successfully!`
        );
        setIsBulkEmployeeAddModal(false);
        setSelectedFile(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      ErrorToast("File upload failed. Please check the console for details.");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setLocalFormData({
      id: 0,
      code: "",
      firstName: "",
      lastName: "",
      profileImageUrl: "",
      reportingManagerId: 0,
      email: "",
      mobile: "",
      gradeId: 0,
      genderId: 0,
      designationId: 0,
      branchId: 0,
      roleId: 0,
      departmentId: 0,
      password: "",
      trackingEnabled: true,
      isActive: true,
    });
    setIsEmployeeAddModal(false);
  };

  console.log("Designation", allDesignation);

  return (
    <>
      <div className="page-wrapper">
        {errorMessage ? (
          <div className="alert alert-danger mt-5" style={{ fontSize: "32px" }}>
            {errorMessage}
          </div>
        ) : (
          <div className="content container-fluid">
            <div className="row">
              <div className="col-12 d-flex align-items-center justify-content-end gap-3">
                {/* <h3 className="mb-0">Add Employee</h3> */}
                <Button
                  size="large"
                  className="mb-3"
                  style={{
                    backgroundColor: "#36c4c9",
                    color: "white",
                    border: "none",
                  }}
                  variant="outlined"
                  onClick={handleBulkAddEmployeeFunction}
                >
                  <i class="fa-solid fa-upload me-2"></i>
                  Bulk Add Employee
                </Button>
                <Button
                  size="large"
                  className="mb-3"
                  style={{
                    backgroundColor: "#36c4c9",
                    color: "white",
                    border: "none",
                  }}
                  variant="solid"
                  onClick={handleAddEmployeeFunction}
                >
                  Add New Employee
                </Button>
              </div>
            </div>

            <UserEmployeeFilterPage parentFunctionLeads={handleFilter} />

            {/* Table */}

            <div className="row mt-4">
              <div className="col-12 mx-auto">
                <Table
                  className="table-striped"
                  style={{ overflowX: "auto" }}
                  columns={columns}
                  dataSource={userData}
                  // dataSource={UserEmployeeData}
                  rowKey={(record) => record.id}
                />
              </div>
            </div>

            {/* Role Modal */}
            <Modal
              title={
                <h4>
                  Add Role For {tempRoleData?.firstName}{" "}
                  {tempRoleData?.lastName}
                </h4>
              }
              open={isRoleModalOpen}
              onCancel={() => setIsRoleModalOpen(false)}
              width={600}
              mask={false}
              footer={[]}
              maskClosable={false}
              closeIcon={<span style={{ color: "red" }}>X</span>}
            >
              <div className="modal-body mt-5">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className="input-block mb-3 leave-duallist">
                      <div className="row">
                        {/* Unassigned Roles */}
                        <div className="col-lg-5 col-sm-5">
                          <label className="col-form-label">
                            Unassigned Role ({selectRoles?.length})
                          </label>
                          <select
                            value={selectedFrom}
                            onChange={(e) => {
                              const selectedValues = Array.from(
                                e.target.options
                              )
                                .filter((option) => option.selected)
                                .map((option) => parseInt(option.value));

                              setSelectedFrom(selectedValues);

                              const newRoleIds = selectedValues
                                .map((id) => {
                                  const option = selectRoles.find(
                                    (option) => option.id === id
                                  );
                                  return option ? option.id : null;
                                })
                                .filter((id) => id !== null);

                              setSelectedRoleIds(newRoleIds);
                            }}
                            className="form-control form-select"
                            size="5"
                            multiple
                          >
                            {selectRoles.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* Controls to move items */}
                        <div className="multiselect-controls col-lg-2 col-sm-2 text-center d-flex flex-column justify-content-center">
                          <button
                            type="button"
                            onClick={moveRightSelected}
                            className="btn btn-white mb-4"
                          >
                            <i className="fa fa-chevron-right" />
                          </button>
                          <button
                            type="button"
                            onClick={moveLeftSelected}
                            className="btn btn-white mb-2"
                          >
                            <i className="fa fa-chevron-left" />
                          </button>
                        </div>

                        {/* Assigned Roles */}
                        <div className="col-lg-5 col-sm-5">
                          <label className="col-form-label">
                            Assigned Role ({selectAssignedRoles?.length})
                          </label>
                          <select
                            value={selectedToFromAssigned} // Track selected values from the right box
                            onChange={(e) => {
                              const selectedValues = Array.from(
                                e.target.options
                              )
                                .filter((option) => option.selected)
                                .map((option) => parseInt(option.value));

                              setSelectedToFromAssigned(selectedValues); // Track selected items
                              const newRoleIds = selectedValues
                                .map((id) => {
                                  const option = selectAssignedRoles.find(
                                    (option) => option.id === id
                                  );
                                  return option ? option.id : null;
                                })
                                .filter((id) => id !== null);

                              setSelectedRoleIds(newRoleIds);
                            }}
                            className="form-control form-select"
                            size="5"
                            multiple
                          >
                            {selectAssignedRoles.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>

            {/* Branch Modal */}

            <Modal
              title={
                <h4>
                  Add Role For {tempBranchData?.firstName}{" "}
                  {tempBranchData?.lastName}
                </h4>
              }
              open={isBranchModalOpen}
              onOk={() => setIsBranchModalOpen(false)}
              onCancel={() => setIsBranchModalOpen(false)}
              width={600}
              footer={null}
              mask={false}
              maskClosable={false}
              closeIcon={<span style={{ color: "red" }}>X</span>}
            >
              <div className="modal-body mt-5">
                <form>
                  <div className="input-block mb-3 leave-duallist">
                    <div className="row">
                      {/* Unassigned Section */}
                      <div className="col-lg-5 col-sm-5">
                        <label className="col-form-label">
                          Unassigned Branch ({optionsFrom?.length})
                        </label>
                        <select
                          value={selectedFrom}
                          onChange={(e) => {
                            const selectedValues = Array.from(e.target.options)
                              .filter((option) => option.selected)
                              .map((option) => parseInt(option.value));

                            setSelectedFrom(selectedValues);

                            const newBranchIds = selectedValues
                              .map((id) => {
                                const option = optionsFrom.find(
                                  (opt) => opt.id === id
                                );
                                return option ? option.id : null;
                              })
                              .filter((id) => id !== null);

                            setSelectedBranchIds(newBranchIds);
                          }}
                          className="form-control form-select"
                          size="5"
                          multiple
                          style={{ height: "200px" }} // Uniform height
                        >
                          {optionsFrom.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Buttons to move data */}
                      <div className="multiselect-controls col-lg-2 col-sm-2 d-flex flex-column justify-content-center align-items-center">
                        {/* Move Right */}
                        <button
                          type="button"
                          onClick={moveRightBranchData}
                          className="btn w-100 btn-white mb-4"
                        >
                          <i className="fa fa-chevron-right" />
                        </button>

                        {/* Move Left */}
                        <button
                          type="button"
                          onClick={moveLeftBranchData}
                          className="btn w-100 btn-white mb-4"
                        >
                          <i className="fa fa-chevron-left" />
                        </button>
                      </div>

                      {/* Assigned Section */}
                      <div className="col-lg-5 col-sm-5">
                        <label className="col-form-label">
                          Assigned Branch ({assigned?.length})
                        </label>
                        <select
                          value={selectedToFromAssigned}
                          onChange={(e) => {
                            const selectedValues = Array.from(e.target.options)
                              .filter((option) => option.selected)
                              .map((option) => parseInt(option.value));

                            setSelectedToFromAssigned(selectedValues); // Track selected items
                            const newBranchIds = selectedValues
                              .map((id) => {
                                const option = assigned.find(
                                  (option) => option.id === id
                                );
                                return option ? option.id : null;
                              })
                              .filter((id) => id !== null);

                            setSelectedBranchIds(newBranchIds);
                          }}
                          className="form-control form-select"
                          size="5"
                          multiple
                          style={{ height: "200px" }} // Uniform height
                        >
                          {assigned.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </Modal>

            {/* Department Modal */}

            <Modal
              title={
                <h4>
                  Add Role For{" "}
                  {tempDepartmentData && tempDepartmentData?.firstName}{" "}
                  {tempDepartmentData && tempDepartmentData?.lastName}
                </h4>
              }
              open={isDepartmentModalOpen}
              onOk={() => setIsDepartmentModalOpen(false)}
              onCancel={() => setIsDepartmentModalOpen(false)}
              footer={[]}
              width={600}
              mask={false}
              maskClosable={false}
              closeIcon={<span style={{ color: "red" }}>X</span>}
            >
              <div className="modal-body mt-5">
                <form>
                  <div className="modal-content">
                    <div className="modal-header"></div>
                    <div className="modal-body">
                      <form>
                        <div className="input-block mb-3 leave-duallist">
                          <div className="row">
                            {/* Unassigned Column */}
                            <div className="col-lg-5 col-sm-5">
                              <label className="col-form-label">
                                Unassigned Department (
                                {selectDepartment?.length})
                              </label>
                              <select
                                value={selectedFrom}
                                onChange={(e) => {
                                  const selectedValues = Array.from(
                                    e.target.options
                                  )
                                    .filter((option) => option.selected)
                                    .map((option) => parseInt(option.value));

                                  setSelectedFrom(selectedValues);

                                  const newDepartmentIds = selectedValues
                                    .map((id) => {
                                      const option = selectDepartment.find(
                                        (option) => option.id === id
                                      );
                                      return option ? option.id : null;
                                    })
                                    .filter((id) => id !== null);

                                  setSelectedDepartmentIds(newDepartmentIds);
                                }}
                                className="form-control form-select"
                                size="5"
                                multiple
                              >
                                {selectDepartment.map((option) => (
                                  <option key={option.value} value={option.id}>
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {/* Control Buttons */}
                            <div className="multiselect-controls col-lg-2 col-sm-2">
                              {/* Remove the moveRightAll and moveLeftAll buttons */}
                              <button
                                type="button"
                                onClick={moveRightAllDepartment}
                                className="btn w-100 btn-white mb-2 mt-4"
                              >
                                <i className="fa fa-forward" />
                              </button>
                              <button
                                type="button"
                                onClick={moveRightDepartment}
                                className="btn w-100 btn-white mb-2"
                              >
                                <i className="fa fa-chevron-right" />
                              </button>
                              <button
                                type="button"
                                onClick={moveLeftDepartment}
                                className="btn w-100 btn-white mb-2"
                              >
                                <i className="fa fa-chevron-left" />
                              </button>
                              <button
                                type="button"
                                // onClick={moveLeftAll}
                                className="btn w-100 btn-white mb-2"
                              >
                                <i className="fa fa-backward" />
                              </button>
                            </div>

                            {/* Assigned Column */}
                            <div className="col-lg-5 col-sm-5">
                              <label className="col-form-label">
                                Assigned Department (
                                {selectAssignDepartment?.length})
                              </label>
                              <select
                                value={selectedToFromAssigned}
                                onChange={(e) => {
                                  const selectedValues = Array.from(
                                    e.target.options
                                  )
                                    .filter((option) => option.selected)
                                    .map((option) => parseInt(option.value));

                                  setSelectedToFromAssigned(selectedValues); // Track selected items
                                  const newDepartmentIds = selectedValues
                                    .map((id) => {
                                      const option =
                                        selectAssignDepartment.find(
                                          (option) => option.id === id
                                        );
                                      return option ? option.id : null;
                                    })
                                    .filter((id) => id !== null);

                                  setSelectedDepartmentIds(newDepartmentIds);
                                }}
                                className="form-control form-select"
                                size="5"
                                multiple
                              >
                                {selectAssignDepartment.map((option) => (
                                  <option key={option.value} value={option.id}>
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </form>
              </div>
            </Modal>

            {/* Add Bulk Employee Modal*/}
            <Modal
              title={<h3 className="text-center">Bulk Upload Employee</h3>}
              open={IsBulkEmployeeAddModal}
              onOk={() => setIsBulkEmployeeAddModal(false)}
              onCancel={() => setIsBulkEmployeeAddModal(false)}
              footer={[
                <div className="d-flex justify-content-center align-items-center">
                  <button
                    key="submit"
                    className="btn btn-primary submit-btn w-100"
                    type="button"
                    onClick={handleUpload}
                    disabled={loading}
                  >
                    {loading ? "Uploading..." : "Submit"}
                  </button>
                </div>,
              ]}
              width={600}
              mask={false}
              maskClosable={false}
              closeIcon={<i className="fa-solid fa-xmark fs-5 text-danger"></i>}
            >
              <div className="modal-body mt-5">
                <Spin
                  spinning={loading}
                  tip="Uploading... Please wait."
                  size="large"
                >
                  <form>
                    <div className="row">
                      <div className="col-md-12">
                        <div>
                          <label htmlFor="inputGroupFile02" className="mb-2">
                            Only XSLX files allowed*
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            id="inputGroupFile02"
                            ref={fileInputRef}
                            disabled={loading}
                            onChange={handleFileChange}
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </Spin>
              </div>
            </Modal>

            {/* Add New Employee Modal*/}
            <Modal
              title={<h3 className="text-center">Add Employee</h3>}
              open={isEmployeeAddModal}
              onOk={() => setIsEmployeeAddModal(false)}
              onCancel={() => setIsEmployeeAddModal(false)}
              footer={[
                <div className="d-flex justify-content-between align-items-center">
                  <button
                    key="Cancel"
                    className="btn btn-danger submit-btn"
                    type="button"
                    onClick={resetForm}
                  >
                    Cancel
                  </button>
                  <button
                    key="submit"
                    className="btn btn-primary submit-btn"
                    type="submit"
                    onClick={addNewEmployeeFunction}
                  >
                    Submit
                  </button>
                </div>,
              ]}
              width={600}
              mask={false}
              maskClosable={false}
              closeIcon={<i className="fa-solid fa-xmark fs-5 text-danger"></i>}
            >
              <div className="modal-body mt-5">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="input-block d-flex flex-column mb-3">
                        <label>
                          Branch <span className="text-danger">*</span>
                        </label>
                        <Select
                          style={{
                            width: "100%",
                            height: "43px",
                            fontSize: "14px",
                            borderRadius: "4px",
                          }}
                          showSearch
                          placeholder="Select Branch"
                          optionFilterProp="label"
                          onChange={(value) =>
                            setLocalFormData({
                              ...LocalFormData,
                              branchId: value,
                            })
                          }
                          options={allbranch.map((branch) => {
                            return {
                              value: branch.id,
                              label: branch.name,
                            };
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Designation <span className="text-danger">*</span>
                        </label>
                        <Select
                          style={{
                            width: "100%",
                            height: "43px",
                            fontSize: "14px",
                            borderRadius: "4px",
                          }}
                          showSearch
                          placeholder="Select Designation"
                          optionFilterProp="label"
                          onChange={(value) =>
                            setLocalFormData({
                              ...LocalFormData,
                              designationId: value,
                            })
                          }
                          options={allDesignation.map((designation) => {
                            return {
                              value: designation.id,
                              label: designation.name,
                            };
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Reporting Manager{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Select
                          style={{
                            width: "100%",
                            height: "43px",
                            fontSize: "14px",
                            borderRadius: "4px",
                          }}
                          showSearch
                          placeholder="Select Reporting Manager"
                          optionFilterProp="label"
                          onChange={(value) =>
                            setLocalFormData({
                              ...LocalFormData,
                              reportingManagerId: value,
                            })
                          }
                          options={userData
                            .filter((user, index, arr) => {
                              return (
                                arr.findIndex((u) => u.id === user.id) === index
                              );
                            })
                            .filter((user) => user.firstName && user.lastName)
                            .map((user) => ({
                              value: user.id,
                              label: `${user.firstName} ${user.lastName}${
                                user.code ? ` (${user.code})` : ""
                              }`,
                            }))}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Gender <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control"
                          value={LocalFormData.genderId}
                          onChange={(e) =>
                            setLocalFormData({
                              ...LocalFormData,
                              genderId: e.target.value,
                            })
                          }
                        >
                          <option value="">Select Gender</option>
                          {selectValueOfGender.map((gender) => (
                            <option key={gender.id} value={gender.id}>
                              {gender.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          First Name <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          value={LocalFormData.firstName}
                          onChange={(e) =>
                            setLocalFormData({
                              ...LocalFormData,
                              firstName: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Last Name <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          value={LocalFormData.lastName}
                          onChange={(e) =>
                            setLocalFormData({
                              ...LocalFormData,
                              lastName: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Code <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          value={LocalFormData.code}
                          onChange={(e) =>
                            setLocalFormData({
                              ...LocalFormData,
                              code: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Password <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          value={LocalFormData.password}
                          onChange={(e) =>
                            setLocalFormData({
                              ...LocalFormData,
                              password: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Email Address <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          value={LocalFormData.email}
                          onChange={(e) =>
                            setLocalFormData({
                              ...LocalFormData,
                              email: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Mobile <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="number"
                          max={10}
                          value={LocalFormData.mobile}
                          onChange={(e) =>
                            setLocalFormData({
                              ...LocalFormData,
                              mobile: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Department <span className="text-danger">*</span>
                        </label>
                        <Select
                          style={{
                            width: "100%",
                            height: "43px",
                            fontSize: "14px",
                            borderRadius: "4px",
                          }}
                          showSearch
                          placeholder="Select Department"
                          optionFilterProp="label"
                          onChange={(value) =>
                            setLocalFormData({
                              ...LocalFormData,
                              departmentId: value,
                            })
                          }
                          options={allDepartment.map((department) => {
                            return {
                              value: department.id,
                              label: department.name,
                            };
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Role <span className="text-danger">*</span>
                        </label>
                        <Select
                          style={{
                            width: "100%",
                            height: "43px",
                            fontSize: "14px",
                            borderRadius: "4px",
                          }}
                          showSearch
                          placeholder="Select Role"
                          optionFilterProp="label"
                          onChange={(value) =>
                            setLocalFormData({
                              ...LocalFormData,
                              roleId: value,
                            })
                          }
                          options={allRole.map((role) => {
                            return {
                              value: role.id,
                              label: role.name,
                            };
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Grade <span className="text-danger">*</span>
                        </label>
                        <Select
                          style={{
                            width: "100%",
                            height: "43px",
                            fontSize: "14px",
                            borderRadius: "4px",
                          }}
                          showSearch
                          placeholder="Select Grade"
                          optionFilterProp="label"
                          onChange={(value) =>
                            setLocalFormData({
                              ...LocalFormData,
                              gradeId: value,
                            })
                          }
                          options={allGrade.map((grade) => {
                            return {
                              value: grade.id,
                              label: grade.name,
                            };
                          })}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <Switch
                      checked={LocalFormData.isActive}
                      onChange={(checked) =>
                        setLocalFormData({
                          ...LocalFormData,
                          isActive: checked,
                        })
                      }
                    />
                    <label className="ms-3">Active</label>
                  </div>

                  <div className="col-md-6 mt-2">
                    <Switch
                      checked={LocalFormData.trackingEnabled}
                      onChange={(checked) =>
                        setLocalFormData({
                          ...LocalFormData,
                          trackingEnabled: checked,
                        })
                      }
                    />
                    <label className="ms-3">Tracking</label>
                  </div>
                </form>
              </div>
            </Modal>

            {/* Edit Employee Data */}
            <Modal
              title={<h4>Edit Employee</h4>}
              open={isEditEmployeeAddModal}
              onOk={() => setIsEditEmployeeAddModal(false)}
              onCancel={() => setIsEditEmployeeAddModal(false)}
              footer={[
                <div className="d-flex justify-content-between align-items-center">
                  <button
                    key="Cancel"
                    className="btn btn-danger submit-btn"
                    type="button"
                    onClick={resetForm}
                  >
                    Cancel
                  </button>
                  ,
                  <button
                    key="submit"
                    className="btn btn-primary submit-btn"
                    type="submit"
                    onClick={() =>
                      EditNewEmployeeFunction(LocalEditFormData?.id)
                    }
                    // onClick={addNewEmployeFuction}
                  >
                    Submit
                  </button>
                </div>,
              ]}
              width={600}
              mask={false}
              maskClosable={false}
              closeIcon={<span style={{ color: "red" }}>X</span>}
            >
              <div className="modal-body mt-5">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      {/* <div className="col-md-6"> */}
                      <div className="input-block mb-3">
                        <label>
                          First Name <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          value={LocalEditFormData.firstName}
                          readOnly
                          onChange={(e) =>
                            setLocalEditFormData({
                              ...LocalEditFormData,
                              firstName: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Last Name <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          value={LocalEditFormData.lastName}
                          readOnly
                          onChange={(e) =>
                            setLocalEditFormData({
                              ...LocalEditFormData,
                              lastName: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Designation <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control"
                          value={LocalEditFormData.designationId}
                          onChange={(e) =>
                            setLocalEditFormData({
                              ...LocalEditFormData,
                              designationId: e.target.value,
                            })
                          }
                        >
                          <option value="">Select Branch</option>
                          {allDesignation.map((designation) => (
                            <option key={designation.id} value={designation.id}>
                              {designation.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Gender <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control"
                          value={LocalEditFormData.genderId}
                          disabled
                        >
                          <option value="">Select Branch</option>
                          {selectValueOfGender.map((gender) => (
                            <option key={gender.id} value={gender.id}>
                              {gender.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Email Address <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          value={LocalEditFormData.email}
                          onChange={(e) =>
                            setLocalEditFormData({
                              ...LocalEditFormData,
                              email: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Mobile <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="number"
                          max={10}
                          value={LocalEditFormData.mobile}
                          onChange={(e) =>
                            setLocalEditFormData({
                              ...LocalEditFormData,
                              mobile: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Grade <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control"
                          value={LocalEditFormData.gradeId}
                          onChange={(e) =>
                            setLocalEditFormData({
                              ...LocalEditFormData,
                              gradeId: e.target.value,
                            })
                          }
                        >
                          <option value="">Select Grade</option>
                          {allGrade.map((grade) => (
                            <option key={grade.id} value={grade.id}>
                              {grade.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </Modal>
          </div>
        )}
      </div>
    </>
  );
}

export default UserEmployeePage;
